import React, {Component, PropTypes} from 'react'
import Calendar from 'rc-calendar';

class ArchiveCalendar extends Component {
  constructor(props) { // gives us acces to props, fires long before page load
    super(props) // assigns props to this.props
    //all the import links are set from the config file
    this.affiliate = props.affiliate;

  }

  onSelect = (moment) =>{
    let date = moment.calendar()
    document.location = `/search?qu=dog&num=${this.maxSearchResults}?date=${date}`

  }


  render() { // REQUIRED
    return (
      <div className='gnm-archive-calendar'>
        <h5>Archive Calendar</h5>
        <Calendar showToday={false} showOk={false} onSelect={this.onSelect}/>
      </div>
    )
  }
}

export default ArchiveCalendar



// WEBPACK FOOTER //
// ./app/components/custom/ssr/ArchiveCalendar/index.js